import { useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { Layout, Footer, MetaData } from '../components/shared';
import ConnectWithUs from '../components/connect-with-us/connect-with-us.component';

import { cmsService } from '../services/homii-services';

const ConnectWithUsPage = (props) => {    
    const { baseUrlApp, data } = props;
    const seoTitle = _.get(data, 'acf.seo_title');
    const seoMetaDesc = _.get(data, 'acf.seo_meta_description');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Layout>
            <MetaData
                title={seoTitle}
                desc={seoMetaDesc}
                canonical={`${baseUrlApp}/connect-with-us`}
            />
            <ConnectWithUs />
            <Footer />
        </Layout>
    );
};

export const getServerSideProps = async ({ }) => {
    const resp = await cmsService.RetrieveWordPressPage('connect-with-us');    
    return {
        props: {
            data: resp
        }
    };
};

ConnectWithUsPage.propTypes = {
    data: PropTypes.object,
    baseUrlApp: PropTypes.string,
};

export default ConnectWithUsPage;
